// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataViewDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingMetadataStatus } from "./routing-metadata-status.enum.gen";
import { RoutingMetadataSidecarDtoGenShape } from "./routing-metadata-sidecar-dto.gen";

export const RoutingMetadataViewDtoGenShape = z.strictObject({
  adviceSetId: z.string(),
  adviceSetName: z.string(),
  libraryId: z.string(),
  adviceSetLastEdited: z.string().optional(),
  status: z.enum(RoutingMetadataStatus),
  sidecars: z.array(RoutingMetadataSidecarDtoGenShape),
});
